module.exports = __webpack_public_path__ + "static/media/banner.0cbd4851.jpg";